import moment from 'moment';

export function parseCityRumors(wpCityRumors) {
	const parsedElements = [];

	for (let cityRumor of wpCityRumors) {
		parsedElements.push({
			title: cityRumor.title.rendered,
			date: moment(cityRumor.date),
			text: trimText(cityRumor.acf.text)
		});
	}

	return parsedElements;
}

function trimText(text) {
	if (text.length >= 300) {
		let trimmedText = text.substring(0, 500);
		return trimmedText += " ...";
	} else {
		return text;
	}
}



// WEBPACK FOOTER //
// ./src/adapters/cityRumors.adapter.js